"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLinesDisplayTotal = void 0;
const getTotalOrderLinesValue_1 = require("./getTotalOrderLinesValue");
const getOrderLinesDisplayTotal = (order_lines, exchange_rate) => {
    if (!exchange_rate || exchange_rate?.rate === 1)
        return 0;
    // format to two decimal places return as number
    return Math.floor((0, getTotalOrderLinesValue_1.getTotalOrderLinesValue)(order_lines) * exchange_rate.rate);
};
exports.getOrderLinesDisplayTotal = getOrderLinesDisplayTotal;
